import { render, staticRenderFns } from "./UserEditModalInterestsList.vue?vue&type=template&id=193d3e36&scoped=true"
import script from "./UserEditModalInterestsList.vue?vue&type=script&lang=js"
export * from "./UserEditModalInterestsList.vue?vue&type=script&lang=js"
import style0 from "./UserEditModalInterestsList.vue?vue&type=style&index=0&id=193d3e36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193d3e36",
  null
  
)

export default component.exports